
import angular from "angular";
import DependencyListBuilder from "../../../../utility/DependencyListBuilder";

import NavbarSearchWidgetController from "./NavbarSearchWidgetController";

const NavbarSearchWidgetComponent = {
    name: "tbNavBarSearchWidget",
    config: {
        template: NavbarSearchWidgetController.template,
        bindings: {
            wrapperClasses: "@tbWrapperClasses"
        },
        controller: NavbarSearchWidgetController,
        controllerAs: NavbarSearchWidgetController.controllerAs
    },
    dependencies: DependencyListBuilder([
        NavbarSearchWidgetController.dependencies
    ])
};

export default angular
    .module(
        "trackerbase-app.views.main-page.nav-bar-search-widget",
        NavbarSearchWidgetComponent.dependencies
    )
    .component(NavbarSearchWidgetComponent.name, NavbarSearchWidgetComponent.config)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageNavbar/NavbarSearchWidget/index.js
// module id = 1pI3
// module chunks = 1